import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  navContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    rowGap: "2rem",
    width: "100vw",
    height: "100vh",
    padding: "1rem",
    paddingTop: "4rem",
  },
  linkContainer: {
    width: "100%",
  },
  link: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: theme.fontFamilyLexendDeca,
    textDecoration: "none",
    textTransform: "uppercase",
    color: theme.darkerGreyColor,
  },
  becomeParterLink: {
    position: "fixed",
    bottom: 0,
    left: 0,
    height: "3rem",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none",
    textTransform: "uppercase",
    fontSize: "0.8rem",
    fontFamily: theme.fontFamilyLexendDeca,
    color: theme.whiteColor,
    backgroundColor: theme.darkSlateGrayColor,
  },
  drawerContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    width: "100vw",
    padding: "1rem",
    paddingTop: "4rem",
    paddingBottom: "3rem",
  },
  divider: {
    borderBottom: `1px solid ${theme.lighterGreyColor}`,
  },
  generalBtn: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
    border: "none",
    backgroundColor: "unset",
  },
  previousBtn: {
    color: theme.lightCoralColor,
    display: "flex",
    justifyContent: "flex-start",
    fontFamily: "'Lexend Deca', sans-serif",
    fontSize: "1rem",
    textTransform: "uppercase",
    columnGap: "0.5rem",
  },
  closeBtn: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
  },
  btnInDrawer: {
    width: "calc(100vw - 2rem)",
    justifyContent: "space-between",
    fontSize: "1rem",
    fontFamily: theme.fontFamilyLexendDeca,
    color: theme.darkerGreyColor,
    textDecoration: "none",
    textTransform: "uppercase",
  },
}));

export default useStyles;
